/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import styled from 'styled-components';
import { getBaseInputStyles, getFloatingInputStyles } from './externals';
export var BasicStyledInput = styled.input.withConfig({
  componentId: "xtxmwa-0"
})(["", " display:block;"], function (props) {
  return getBaseInputStyles(props);
});
export var FloatingStyledInput = styled.input.withConfig({
  componentId: "xtxmwa-1"
})(["", " display:block;"], function (props) {
  return getFloatingInputStyles(props);
});